// Static imports
import PartnerIndex from '@/views/member/partner'
import ListPage from '@/views/member/partner/pages/list'
import List2Page from '@/views/member/partner/pages/list2'
import PartnerCreatePage from '@/views/member/partner/pages/partnerCreate'
import PartnerDetailPage from '@/views/member/partner/pages/partnerdetail.vue'
import ReportDetailPage from '@/views/member/partner/pages/report_detail'
import SettingPage from '@/views/member/partner/pages/setting'
import SummaryPage from '@/views/member/partner/pages/summary'
import PayoutPage from '@/views/member/partner/pages/payout'

export default {
  name: 'Partner',
  path: '/partner',
  component: PartnerIndex,
  redirect: {
    name: 'partnerList'
  },
  meta: {
    layout: 'default',
    isActive: false,
    text: '파트너 관리',
    icon: 'icon_partner',
    code: 'LV060000'
  },
  children: [
    {
      name: 'partnerList',
      path: '/partner/list',
      component: ListPage,
      meta: {
        menuMember: true,
        text: '파트너 목록',
        done: true
        // code: 'LV060100'
      }
    },
    {
      name: 'partnerList2',
      path: '/partner/list2',
      component: List2Page,
      meta: {
        menuMember: true,
        text: '파트너 목록',
        done: true,
        code: 'LV060100'
        // code: 'LV060500'
      }
    },
    {
      name: 'partnerCreate',
      path: '/partner/partnerCreate',
      component: PartnerCreatePage,
      meta: {
        menuMember: true,
        text: '파트너 생성',
        code: 'LV060600'
      }
    },
    {
      name: 'partnerCreateView',
      path: '/partner/partnerCreateView',
      component: PartnerCreatePage,
      meta: {
        layout: 'popup',
        menuMember: true,
        text: '파트너 생성'
      }
    },
    {
      name: 'partnerDetail',
      path: '/partner/partnerDetail',
      component: PartnerDetailPage,
      meta: {
        menuMember: true,
        text: '파트너 상세',
        code: 'LV060700'
      }
    },
    {
      name: 'partnerDetailView',
      path: '/partner/partnerDetailView',
      component: PartnerDetailPage,
      meta: {
        layout: 'popup',
        menuMember: true,
        text: '파트너 상세'
      }
    },
    // {
    //   name: 'PartnerTermReport',
    //   path: '/partner/reportTerm',
    //   component: () => import('@/views/member/partner/pages/report_term'),
    //   meta: {
    //     menuMember: true,
    //     text: '파트너 기간별 정산내역'
    //   }
    // },
    {
      name: 'PartnerDetailReport',
      path: '/partner/reportDetail',
      component: ReportDetailPage,
      meta: {
        menuMember: true,
        text: '파트너 정산 상세내역',
        code: 'LV060200'
      }
    },
    {
      name: 'PartnerSetting',
      path: '/partner/setting',
      component: SettingPage,
      meta: {
        menuMember: true,
        text: '파트너 설정',
        code: 'LV060300'
      }
    },

    {
      name: 'PartnerSummary',
      path: '/partner/summary',
      component: SummaryPage,
      meta: {
        menuMember: true,
        text: '파트너 포인트 요약',
        code: 'LV060400'
      }
    },
    {
      name: 'PartnerPayout',
      path: '/partner/payout',
      component: PayoutPage,
      meta: {
        menuMember: true,
        text: '공지사항'
        // code: 'LV060500'
      }
    }
  ]
}
